export default "__VITE_ASSET__CJSttBfF__"